import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import crypto from "crypto";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";

var Rememberme = /*#__PURE__*/function () {
  function Rememberme() {
    var _config$rememberme$re, _config$rememberme$re2, _config$rememberme$re3, _config$rememberme, _config$rememberme$re4;

    _classCallCheck(this, Rememberme);

    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$rememberme$re = config.rememberme.redis) === null || _config$rememberme$re === void 0 ? void 0 : _config$rememberme$re.host),
      port: process.env.REDIS_PORT || ((_config$rememberme$re2 = config.rememberme.redis) === null || _config$rememberme$re2 === void 0 ? void 0 : _config$rememberme$re2.port),
      keyPrefix: config.rememberme.redis.prefix,
      db: (_config$rememberme$re3 = config.rememberme.redis) === null || _config$rememberme$re3 === void 0 ? void 0 : _config$rememberme$re3.db
    }, (_config$rememberme = config.rememberme) === null || _config$rememberme === void 0 ? void 0 : (_config$rememberme$re4 = _config$rememberme.redis) === null || _config$rememberme$re4 === void 0 ? void 0 : _config$rememberme$re4.cluster);
  }

  _createClass(Rememberme, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, payload) {
        var encryptedData, _yield$this$redis$mul, _yield$this$redis$mul2, err, results;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                encryptedData = encrypto(JSON.stringify(payload));
                _context.next = 3;
                return this.redis.multi().set(id, encryptedData).expire(id, config.token.maxAge).exec();

              case 3:
                _yield$this$redis$mul = _context.sent;
                _yield$this$redis$mul2 = _slicedToArray(_yield$this$redis$mul, 2);
                err = _yield$this$redis$mul2[0];
                results = _yield$this$redis$mul2[1];
                console.log(err, results);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save(_x, _x2) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.redis.expire(id, config.token.maxAge);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refresh(_x3) {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var data, decryptedData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.redis.get(key);

              case 2:
                data = _context3.sent;
                decryptedData = decrypto(data);
                return _context3.abrupt("return", JSON.parse(decryptedData));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get(_x4) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.redis.del(key);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return Rememberme;
}();

export { Rememberme as default };

function encrypto(data) {
  var settings = config.rememberme.crypto;
  var key = crypto.scryptSync(settings.password, settings.salt, 32);
  var iv = crypto.randomBytes(16);
  var cipher = crypto.createCipheriv(settings.algo, key, iv);
  var encryptedData = cipher.update(data);
  encryptedData = Buffer.concat([encryptedData, cipher.final()]);
  return Buffer.concat([iv, encryptedData]).toString("hex");
}

function decrypto(encryptedData) {
  var buffer = Buffer.from(encryptedData, "hex");
  var iv = buffer.slice(0, 16);
  var data = buffer.slice(16);
  var settings = config.rememberme.crypto;
  var key = crypto.scryptSync(settings.password, settings.salt, 32);
  var decipher = crypto.createDecipheriv(settings.algo, key, iv);
  var decryptedData = decipher.update(data);
  decryptedData = Buffer.concat([decryptedData, decipher.final()]);
  return decryptedData;
}